import { CadastroFrom } from "./pages/cadastros/cadastro";
function App() {
  // const [count, setCount] = useState(0)

  return (
    <div>
      <CadastroFrom />
    </div>
  );
}

export default App;
